import React from 'react'
import Text from '@component/Text/Text'

interface IProps {
    text?: string
    subText?: string
    onClick?: () => void
    className?: string
}

const MobileNavigationItem: React.FC<IProps> = ({text, subText, onClick, className}) => {
    return (
        <div
            className={`px-[20px] py-[15px] border-y border-gray07 dark:border-dark_gray07 flex justify-between items-center cursor-pointer ${className}`}
            onClick={onClick}>
            <Text className={'text-ti1 text-gray01 dark:text-dark_gray01'}>{text}</Text>
            <Text className={'text-body2 text-gray02 dark:text-dark_gray02'}>{subText}</Text>
        </div>
    )
}

export default MobileNavigationItem
